module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popupBg",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.pressDone.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popupArea bg-lightest px-3 d-flex flex-column justify-content-between"
  }, [_c('div', [_c('transport-extras-selector', {
    attrs: {
      "reservation": _vm.getSelectedReservation
    }
  }), _vm._v(" "), (!_vm.routes) ? _c('div', {
    staticClass: "text-center"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('transport-editor', {
    attrs: {
      "transfer": _vm.getSelectedReservation.transport.transfers[0],
      "routes": _vm.routes,
      "reservation": _vm.getSelectedReservation,
      "title": "Pick up location",
      "type": 1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 mb-3 text-right pos-rel"
  }, [_c('button', {
    staticClass: "btn primary wider ml-2",
    on: {
      "click": _vm.pressDone
    }
  }, [_vm._v("Done")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-88c9da2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88c9da2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/EditTransport.vue
// module id = 1936
// module chunks = 0